import { SET_ANM_ID_SELECTED, SET_GO_TO_BENEFICIARY_DETAIL_PAGE_FROM_WORK_PLAN, SET_SHOW_WORK_PLAN_ADD_BENF_LIST, SET_SHOW_WORK_PLAN_DUE_LIST, SET_WORK_PLAN_BENF_DUE_LIST_FLOW_FROM, SET_WORK_PLAN_BENF_DUE_LIST_PAGE_TYPE, SET_WORK_PLAN_CALENDAR_BENEF_ID, SET_WORK_PLAN_DATA, SET_WORK_PLAN_REMOVAL_REASON_DATA, SET_WORK_PLAN_SELECTED_DATE, SET_WORK_PLAN_SELECTED_SERVICES_ID, workPlanType } from "@store/types/workPlanTypes";

export interface WorkPlanState {
    workPlanData: any;
    showWorkPlanDueList: any;
    showWorkPlanAddBenfList: any;
    workPlanListPageType: any;
    workPlanFlowFrom: any;
    selectedCalenderDate: any;
    selectedServiceId: any[];
    workPlanRemovalReasonData: any;
    selectedBenefIdsFromCalender: any[];
    selectedAnmIdByMoic: any;
    goToBenefDetailPage: any;
};

const workPlanReducer = (
    state = {
        workPlanData: null,
        showWorkPlanDueList: false,
        showWorkPlanAddBenfList: false,
        workPlanListPageType: '',
        workPlanFlowFrom: '',
        selectedCalenderDate: '',
        selectedServiceId: [],
        workPlanRemovalReasonData: null,
        selectedBenefIdsFromCalender: [],
        selectedAnmIdByMoic: null,
        goToBenefDetailPage: {
            isFromWorkPlan: false
        }
    },
    action: workPlanType,
): WorkPlanState => {
    switch (action.type) {
        case SET_WORK_PLAN_DATA:
            return { ...state, workPlanData: action.payload };

        case SET_SHOW_WORK_PLAN_DUE_LIST:
            return { ...state, showWorkPlanDueList: action.payload };

        case SET_SHOW_WORK_PLAN_ADD_BENF_LIST:
            return { ...state, showWorkPlanAddBenfList: action.payload };

        case SET_WORK_PLAN_BENF_DUE_LIST_PAGE_TYPE:
            return { ...state, workPlanListPageType: action.payload };

        case SET_WORK_PLAN_BENF_DUE_LIST_FLOW_FROM:
            return { ...state, workPlanFlowFrom: action.payload };

        case SET_WORK_PLAN_SELECTED_DATE:
            return { ...state, selectedCalenderDate: action.payload };

        case SET_WORK_PLAN_SELECTED_SERVICES_ID:
            return { ...state, selectedServiceId: action.payload };

        case SET_WORK_PLAN_REMOVAL_REASON_DATA:
            return { ...state, workPlanRemovalReasonData: action.payload };

        case SET_WORK_PLAN_CALENDAR_BENEF_ID:
            return { ...state, selectedBenefIdsFromCalender: action.payload };

        case SET_ANM_ID_SELECTED:
            return { ...state, selectedAnmIdByMoic: action.payload };

        case SET_GO_TO_BENEFICIARY_DETAIL_PAGE_FROM_WORK_PLAN:
            return { ...state, goToBenefDetailPage: action.payload };

        default:
            return state;
    }
};

export default workPlanReducer;